import { ReactElement, ReactNode } from 'react';
import { ReportType } from 'shared/domain/report/types/model/common';
import {
  InspectionReportAvailabilityProvider,
  SingleIssueReportAvailabilityProvider,
} from './ReportSectionAvailabilityContext';

export function ReportAvailabilityShell({
  reportType,
  open,
  children,
}: {
  reportType: ReportType;
  open: boolean;
  children: ReactNode;
}): ReactElement {
  switch (reportType) {
    case ReportType.singleIssue:
      return (
        <SingleIssueReportAvailabilityProvider open={open}>
          {children}
        </SingleIssueReportAvailabilityProvider>
      );
    case ReportType.issueList:
      // Availability for issue list lives under MultiIssueFilteredIssuesProvider
      // inside ReportFormEstimateShell (must read the same fetched issue set).
      return <>{children}</>;
    case ReportType.inspection:
      return (
        <InspectionReportAvailabilityProvider>
          {children}
        </InspectionReportAvailabilityProvider>
      );
    default: {
      const _exhaustive: never = reportType;
      return _exhaustive;
    }
  }
}
